// HO-TASK-296: la API no devuelve más de 100 filas por página. Pedir
// limit=99999999 para traer "todo" deja de funcionar: el backend lo recorta
// a 100 y el resto de las filas se pierde sin ningún error.
export const MAX_PAGE_SIZE = 100;

// Freno de seguridad: 50 páginas son 5.000 filas. Si un listado supera eso,
// la pantalla debería paginar o filtrar en el backend, no traer todo.
const MAX_PAGES = 50;

/**
 * Trae todas las páginas de un listado paginado de la API, de a 100 filas, y
 * las junta en una sola respuesta con la misma forma que antes daba un
 * limit=99999999: `data` con todas las filas y `meta` de una sola página.
 *
 * Las páginas se piden una tras otra, no en paralelo, para no gastar de golpe
 * el cupo del rate limit (HO-TASK-295).
 *
 * @param {(page: number, pageSize: number) => Promise<object>} fetchPage
 *   Pide una página. Recibe el número de página y el tamaño.
 */
export const fetchAllPages = async (fetchPage) => {
  const firstPage = await fetchPage(1, MAX_PAGE_SIZE);

  if (!Array.isArray(firstPage?.data)) {
    return firstPage;
  }

  const lastPage = Number(firstPage.meta?.last_page ?? firstPage.last_page) || 1;
  const pagesToFetch = Math.min(lastPage, MAX_PAGES);

  if (lastPage > MAX_PAGES) {
    console.warn(
      `fetchAllPages: el listado tiene ${lastPage} páginas; solo se traen las primeras ${MAX_PAGES}.`
    );
  }

  const rows = [...firstPage.data];
  for (let page = 2; page <= pagesToFetch; page++) {
    const response = await fetchPage(page, MAX_PAGE_SIZE);
    rows.push(...(response?.data || []));
  }

  if (!firstPage.meta) {
    return { ...firstPage, data: rows };
  }

  return {
    ...firstPage,
    data: rows,
    meta: {
      ...firstPage.meta,
      current_page: 1,
      last_page: 1,
      per_page: rows.length,
    },
  };
};
